import { createSlice } from "@reduxjs/toolkit";

export const defaultCuisineOptions = [
  { label: "Multi", value: "Multi" },
  { label: "Indian", value: "Indian" },
  { label: "Chinese", value: "Chinese" },
  { label: "Continental", value: "Continental" },
  { label: "Cafe & Bakery", value: "Cafe & Bakery" },
  { label: "Italian", value: "Italian" },
  { label: "Fast Food", value: "Fast Food" },
];

const initialState = {
  cuisineTypes: defaultCuisineOptions,
  userRoles: [],
  userPermissions: [],
};

const dropdownSlice = createSlice({
  name: "dropdown",
  initialState,
  reducers: {
    setCuisineTypes: (state, action) => {
      state.cuisineTypes = action.payload;
    },
    setUserRoles: (state, action) => {
      state.userRoles = action.payload;
    },
    setUserPermissions: (state, action) => {
      state.userPermissions = action.payload;
    },
  },
});

export const { setCuisineTypes, setUserRoles, setUserPermissions } =
  dropdownSlice.actions;

export default dropdownSlice.reducer;
